<div class="h-100">
  <form [formGroup]="model.asForm" (ngSubmit)="enviar()">
    <div class="d-flex justify-content-center mt-4 mb-14px">
      <div style="width: 79px;height: 5px; border-radius: 41px; background-color: #D9D9D9"></div>
    </div>
    <h3 class="h3-us mb-3"><img class="me-2" src="assets/imgs/icones/info-azul.svg" alt=""> Novo Documento</h3>
    <div class="form-group mb-3">
      <label>Novo Documento</label>
      <div class="d-block">
        <button class="btn btn-dashed"  type="button" (click)="fileInput.click()">
          <span>Apenas ".png", ".jpg", ".jpeg" ou ".pdf". <img class="ms-2" src="assets/imgs/icones/upload.svg" alt=""></span>
        </button>
        <input hidden (change)="uploadArquivo($event)" #fileInput type="file" id="file"
               [ngClass]="{'is-invalid': (!nomeArquivo && model.form.controls.base64.invalid && !validarFormulario) ||
                (model.form.controls.extensao.invalid && nomeArquivo)}">
        <div *ngIf="nomeArquivo && model.form.controls.extensao.valid" class="mt-1 w-100 d-flex">
            <span class="txt-nome-arquivo-upload color-primario d-inline-block text-truncate" style="max-width: 240px;">
                {{nomeArquivo}}
            </span>
          <img src="assets/imgs/icones/check-verde.svg" class="ms-1" alt="">
        </div>

        <div class="invalid-feedback">
          {{ nomeArquivo && model.form.controls?.extensao?.invalid ? msgErroDocumento : 'Campo obrigatório'}}
        </div>
      </div>
    </div>
    <div>
      <app-input-select class="w-100" [label]="'Qual documento você está enviando?'"
                        [id]="'tipoDocumento'" [tipoSelectNumber]="false" [placeholder]="''"
                        formControlName="tipoDocumento"
                        [invalid]="model.form.controls.tipoDocumento.invalid && !validarFormulario"
                        [list]="listaDocumentos"></app-input-select>
    </div>
    <div class="mt-3">
      <div class="row">
        <div class="col-6">
          <button type="button" class="btn btn-outline-secondary btn-sm w-100" (click)="fechar()">Cancelar</button>
        </div>
        <div class="col-6">
          <button type="submit" class="btn btn-primary float-end btn-sm w-100">Ok</button>
        </div>
      </div>
    </div>
  </form>
</div>
